const initConstructionProgress = () => {
	document.addEventListener("DOMContentLoaded", function () {
		const sections = document.querySelectorAll("section.construction-progress");

		if (sections.length) {
			Array.from(sections).forEach((section) => {
				const frame = section.querySelector("iframe");
				frame.src = frame.dataset.src;
			});
		}
	});
};

export { initConstructionProgress };
